const API = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "imj_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (token) => (token ? localStorage.setItem(TOKEN_KEY, token) : localStorage.removeItem(TOKEN_KEY));

// FastAPI validation errors arrive as arrays of {msg}; normalise to a readable string.
export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const api = async (path, { method = "GET", body, auth = false } = {}) => {
  const headers = { "Content-Type": "application/json" };
  if (auth && getToken()) headers.Authorization = `Bearer ${getToken()}`;
  const res = await fetch(`${API}${path}`, { method, headers, credentials: "include", body: body ? JSON.stringify(body) : undefined });
  if (res.status === 204) return null;
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(formatApiError(data.detail));
    err.status = res.status;
    throw err;
  }
  return data;
};

export const formatPostDate = (iso, lang) =>
  new Date(iso).toLocaleDateString(lang === "te" ? "te-IN" : "en-IN", { day: "numeric", month: "long", year: "numeric" });

export const youtubeEmbed = (url) => {
  const m = url?.match(/(?:youtu\.be\/|v=|shorts\/)([\w-]{11})/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
};
